import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, take } from 'rxjs';
import { TenantInnerService } from '../_services/tenant-inner.service';
import { TokenService } from '../_services/token.service';
import { MERCK_TENANT } from './Constants';

/**
 * Allows activation only while the currently selected tenant is Merck.
 * Any other tenant (admins included, since they can switch tenants) is redirected home.
 */
export const MerckTenantGuard: CanActivateFn = (_route, state) => {
  const tokenService = inject(TokenService);
  const tenantInnerService = inject(TenantInnerService);
  const router = inject(Router);

  if (tokenService.getToken() === null) {
    localStorage.setItem('redirectUrl', state.url);
    router.navigateByUrl('/');
    return false;
  }

  // On direct URL navigation setUserTenant() may not have been called yet,
  // so curTenant$ has no value to replay. Trigger loading if needed.
  if (!tenantInnerService.getCurTenant()) {
    tenantInnerService.setUserTenant();
  }

  return tenantInnerService.curTenant$.pipe(
    take(1),
    map((tenant) => {
      if (tenant?.name === MERCK_TENANT) {
        return true;
      }
      router.navigateByUrl('/');
      return false;
    })
  );
};
